var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 14C17.9201 14 18.4802 14 18.908 13.782C19.2843 13.5903 19.5903 13.2843 19.782 12.908C20 12.4802 20 11.9201 20 10.8V3.2V3.19997C20 2.07989 20 1.51984 19.782 1.09202C19.5903 0.715696 19.2843 0.409735 18.908 0.217988C18.4802 0 17.9201 0 16.8 0H3.2C2.0799 0 1.51984 0 1.09202 0.217987C0.715695 0.409734 0.409734 0.715695 0.217987 1.09202C0 1.51984 0 2.07989 0 3.2V10.8C0 11.9201 0 12.4802 0.217987 12.908C0.409734 13.2843 0.715695 13.5903 1.09202 13.782C1.51984 14 2.07989 14 3.2 14L16.8 14ZM4 4.5C4.27614 4.5 4.5 4.72386 4.5 5V9C4.5 9.27614 4.27614 9.5 4 9.5C3.72386 9.5 3.5 9.27614 3.5 9V5C3.5 4.72386 3.72386 4.5 4 4.5ZM16 4.5C16.2761 4.5 16.5 4.72386 16.5 5V9C16.5 9.27614 16.2761 9.5 16 9.5C15.7239 9.5 15.5 9.27614 15.5 9V5C15.5 4.72386 15.7239 4.5 16 4.5ZM10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z",
    fill: "#333F48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCash);
export default __webpack_public_path__ + "static/media/icon_cash.f3515f4cd0955c6cab73b8bb22eed7bd.svg";
export { ForwardRef as ReactComponent };